/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunColorDTO } from './RunColorDTO';
import {
    RunColorDTOFromJSON,
    RunColorDTOFromJSONTyped,
    RunColorDTOToJSON,
} from './RunColorDTO';

/**
 * 
 * @export
 * @interface RunColorsDTO
 */
export interface RunColorsDTO {
    /**
     * Colors of the requested entities that have one in the list
     * @type {Array<RunColorDTO>}
     * @memberof RunColorsDTO
     */
    colors: Array<RunColorDTO>;
}

/**
 * Check if a given object implements the RunColorsDTO interface.
 */
export function instanceOfRunColorsDTO(value: object): value is RunColorsDTO {
    if (!('colors' in value) || value['colors'] === undefined) return false;
    return true;
}

export function RunColorsDTOFromJSON(json: any): RunColorsDTO {
    return RunColorsDTOFromJSONTyped(json, false);
}

export function RunColorsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunColorsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'colors': ((json['colors'] as Array<any>).map(RunColorDTOFromJSON)),
    };
}

export function RunColorsDTOToJSON(value?: RunColorsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'colors': ((value['colors'] as Array<any>).map(RunColorDTOToJSON)),
    };
}

